import React from 'react'
import { Box } from './demoKit'

/**
 * Layouts / grids — rewrite limpo (UI Card).
 * CSS crítico vai num <style> injetado para não depender de CSS module stale.
 * Proporções via <table table-layout:fixed> (percentuais confiáveis).
 */

const WF_CSS = `
.wf-demo { --wf-g: 16px; --wf-hero: #e8a04a; --wf-muted: #cfd4dc; --wf-support: #b8c0cc;
  --wf-filter: #9aa6b5; --wf-ink: #273351; padding: 4px 0; width: 100%; min-width: 0; box-sizing: border-box; }
.wf-demo__head h3 { margin: 0 0 4px; font-size: 1rem; color: var(--wf-ink); }
.wf-demo__head p, .wf-demo__lead { margin: 0 0 12px; font-size: 0.85rem; color: #5a6570; }
.wf-demo__foot { margin: 14px 0 0; font-size: 0.78rem; color: #5a6570; }
.wf-demo__foot code { font-size: 0.75rem; }
.wf-overview { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; }
@media (max-width: 900px) { .wf-overview { grid-template-columns: 1fr; } }
.wf-frame { margin: 0; }
.wf-frame__cap { font-size: 0.78rem; font-weight: 600; color: var(--wf-ink); margin-bottom: 6px; }
.wf-frame__stage { background: #f4f1ea; border: 1px solid #e2ddd3; border-radius: 6px;
  padding: 16px; width: 100%; min-width: 0; box-sizing: border-box; }
.wf-frame__note { margin: 6px 0 0; font-size: 0.72rem; color: #6c757d; }

.wf-table { width: 100%; border-collapse: separate; border-spacing: var(--wf-g) var(--wf-g);
  table-layout: fixed; margin: 0; }
.wf-table td { padding: 0; vertical-align: top; }
.wf-cell { display: flex; align-items: center; justify-content: center; text-align: center;
  font-size: 0.68rem; font-weight: 600; letter-spacing: 0.02em; text-transform: uppercase;
  color: #3a4556; background: var(--wf-muted); border-radius: 4px; min-height: 36px;
  padding: 6px 8px; box-sizing: border-box; width: 100%; }
.wf-cell--band { min-height: 28px; font-size: 0.62rem; }
.wf-cell--hero { background: var(--wf-hero); color: #3a2a12; min-height: 0; }
.wf-cell--support { background: var(--wf-support); min-height: 0; }
.wf-cell--filter { background: var(--wf-filter); color: #fff;
  writing-mode: vertical-rl; transform: rotate(180deg); letter-spacing: 0.08em; }
.wf-cell--tall { min-height: 100px; }
.wf-cell--feed { min-height: 88px; }

.wf-stack { display: flex; flex-direction: column; gap: var(--wf-g); width: 100%; min-width: 0; }
.wf-screen { display: flex; flex-direction: column; gap: var(--wf-g); width: 100%; min-height: 460px; height: 100%; }
.wf-band { display: grid; gap: var(--wf-g); width: 100%; flex: 0 0 auto; }
.wf-fill { flex: 1 1 auto; min-height: 0; display: grid; gap: var(--wf-g); align-items: stretch; }
.wf-fill > .wf-cell { height: 100%; min-height: 100%; }
.wf-split { display: grid; gap: var(--wf-g); width: 100%; align-items: stretch; }
.wf-split > .wf-cell { height: 100%; min-height: 120px; }
.wf-split--main > .wf-cell { min-height: 240px; }
.wf-explore {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-template-rows: auto minmax(100px, 1fr) minmax(72px, 1fr);
  grid-template-areas:
    "filter slot1 slot2 slot3"
    "filter analysis analysis analysis"
    "filter detail detail detail";
  gap: var(--wf-g);
  width: 100%;
  min-width: 0;
  min-height: 280px;
}
.wf-explore--screen { min-height: 460px; height: 100%; flex: 1; grid-template-rows: auto 1.2fr 1fr; }
.wf-explore__filter { grid-area: filter; min-height: 0 !important; height: 100% !important; }
.wf-explore__slot1 { grid-area: slot1; }
.wf-explore__slot2 { grid-area: slot2; }
.wf-explore__slot3 { grid-area: slot3; }
.wf-explore__analysis { grid-area: analysis; min-height: 0; height: 100%; }
.wf-explore__detail { grid-area: detail; min-height: 0; height: 100%; }
.wf-frame--screen .wf-frame__stage { min-height: 460px; display: flex; flex-direction: column; }
.wf-frame--screen .wf-frame__stage > .wf-screen { flex: 1; }

.wf-types { display: grid; grid-template-columns: repeat(3, minmax(0,1fr)); gap: 12px; margin-top: 24px; }
@media (max-width: 900px) { .wf-types { grid-template-columns: 1fr 1fr; } }
.wf-type { border: 1px solid #e2e6ec; border-radius: 6px; padding: 10px 12px; background: #fff;
  display: flex; flex-direction: column; gap: 4px; }
.wf-type strong { font-size: 0.82rem; color: var(--wf-ink); }
.wf-type span { font-size: 0.75rem; color: #5a6570; }

.wf-spacing-list { display: flex; flex-direction: column; gap: 10px; margin-bottom: 24px; }
.wf-spacing-row { display: grid; grid-template-columns: minmax(0,1.2fr) minmax(0,1fr); gap: 12px;
  align-items: center; padding: 8px 10px; border: 1px solid #e2e6ec; border-radius: 6px; background: #fff; }
.wf-spacing-row__meta { display: flex; flex-wrap: wrap; gap: 6px 10px; align-items: baseline; }
.wf-spacing-row__meta code { font-size: 0.72rem; }
.wf-spacing-row__meta strong { font-size: 0.85rem; color: var(--wf-ink); }
.wf-spacing-row__meta span { flex: 1 1 100%; font-size: 0.72rem; color: #5a6570; }
.wf-spacing-row__viz { display: flex; align-items: stretch; min-height: 28px; }
.wf-spacing-row__viz i { flex: 1; background: var(--wf-hero); border-radius: 3px; opacity: 0.85; }
.wf-spacing-sample { background: #f4f1ea; border: 1px solid #e2ddd3; border-radius: 6px; padding: 16px; }

.wf-zone-map { display: grid; grid-template-columns: repeat(2, minmax(0,1fr)); gap: 16px; }
@media (max-width: 900px) { .wf-zone-map { grid-template-columns: 1fr; } }
.wf-zone-map__card { border: 1px solid #e2e6ec; border-radius: 6px; padding: 12px; background: #fff; }
.wf-zone-map__card strong { display: block; font-size: 0.85rem; color: var(--wf-ink); margin-bottom: 8px; }
.wf-zone-map__card ul { list-style: none; margin: 0; padding: 0; }
.wf-zone-map__card li { display: flex; justify-content: space-between; gap: 8px; padding: 4px 0;
  border-top: 1px solid #eef1f5; font-size: 0.75rem; }
.wf-zone-map__card li span { color: var(--wf-ink); }
.wf-zone-map__card li code { font-size: 0.7rem; color: #5a6570; }

.wf-nav { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
@media (max-width: 700px) { .wf-nav { grid-template-columns: 1fr; } }
.wf-nav__item { border: 1px solid #e2e6ec; border-radius: 6px; padding: 10px 12px; background: #fff; }
.wf-nav__item strong { display: block; font-size: 0.82rem; color: var(--wf-ink); }
.wf-nav__item span { font-size: 0.75rem; color: #5a6570; }

.wf-mark { display: inline-block; margin-left: 8px; padding: 1px 6px; border-radius: 3px;
  background: #1c47a4; color: #fff; font-size: 0.65rem; font-weight: 700; letter-spacing: 0.04em; }
`

function WfStyles() {
  return <style dangerouslySetInnerHTML={{ __html: WF_CSS }} />
}

function Cell({ children, tone = 'muted', className = '' }) {
  const toneClass =
    tone === 'band'
      ? 'wf-cell--band'
      : tone === 'hero'
        ? 'wf-cell--hero'
        : tone === 'support'
          ? 'wf-cell--support'
          : tone === 'filter'
            ? 'wf-cell--filter'
            : ''
  return <div className={`wf-cell ${toneClass} ${className}`.trim()}>{children}</div>
}

function Frame({ title, children, note, screen }) {
  return (
    <figure className={`wf-frame${screen ? ' wf-frame--screen' : ''}`}>
      <figcaption className="wf-frame__cap">
        {title}
        <span className="wf-mark">WF2</span>
      </figcaption>
      <div className="wf-frame__stage">{children}</div>
      {note ? <p className="wf-frame__note">{note}</p> : null}
    </figure>
  )
}

/** Faixa de divisões iguais. O rótulo é a largura, não um componente. */
function Band({ count, label }) {
  return (
    <div className="wf-band" style={{ gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))` }}>
      {Array.from({ length: count }, (_, i) => (
        <Cell key={i} tone="band">
          {label}
        </Cell>
      ))}
    </div>
  )
}

/** Clássico Z — 4×25%, herói 75% / apoio 25%, base 50/50. */
function WireZ({ screen }) {
  return (
    <div className={screen ? 'wf-screen' : 'wf-stack'}>
      <Band count={4} label="25%" />
      <div className={screen ? 'wf-fill' : 'wf-split'} style={{ gridTemplateColumns: '3fr 1fr' }}>
        <Cell tone="hero">Gráfico herói · 75%</Cell>
        <Cell tone="support">Apoio · 25%</Cell>
      </div>
      <div className={screen ? 'wf-fill' : 'wf-split'} style={{ gridTemplateColumns: '1fr 1fr' }}>
        <Cell>Visual de apoio · 50%</Cell>
        <Cell>Visual de apoio · 50%</Cell>
      </div>
    </div>
  )
}

/** 70/30 — faixa 4×25%; principal e apoio preenchem a altura restante. */
function Wire7030({ screen }) {
  return (
    <div className={screen ? 'wf-screen' : 'wf-stack'}>
      <Band count={4} label="25%" />
      <div
        className={screen ? 'wf-fill' : 'wf-split wf-split--main'}
        style={{ gridTemplateColumns: '7fr 3fr' }}
      >
        <Cell tone="hero">Visual principal · 70%</Cell>
        <Cell tone="support">Coluna apoio · 30%</Cell>
      </div>
    </div>
  )
}

/**
 * Exploração — grade 4×25%: filtro | faixa | faixa | faixa.
 * Análise e detalhe preenchem as 3 cols da direita.
 */
function WireExplore({ screen }) {
  return (
    <div className={`wf-explore${screen ? ' wf-explore--screen' : ''}`}>
      <Cell tone="filter" className="wf-explore__filter">
        Filtros · 25%
      </Cell>
      <Cell tone="band" className="wf-explore__slot1">
        25%
      </Cell>
      <Cell tone="band" className="wf-explore__slot2">
        25%
      </Cell>
      <Cell tone="band" className="wf-explore__slot3">
        25%
      </Cell>
      <Cell tone="hero" className="wf-explore__analysis">
        Área de análise · 75%
      </Cell>
      <Cell className="wf-explore__detail">Tabela de detalhe · 75%</Cell>
    </div>
  )
}

function WireExec({ screen }) {
  return (
    <div className={screen ? 'wf-screen' : 'wf-stack'}>
      <Cell>Resumo executivo · 100%</Cell>
      <Band count={4} label="25%" />
      <div className={screen ? 'wf-fill' : undefined}>
        <Cell tone="hero" className={screen ? '' : 'wf-cell--tall'}>
          Um gráfico, só um · 100%
        </Cell>
      </div>
    </div>
  )
}

/** Comparativa — 3 faixas de ⅓; painéis 50/50; desvios 100%. */
function WireCompare({ screen }) {
  return (
    <div className={screen ? 'wf-screen' : 'wf-stack'}>
      <Band count={3} label="33%" />
      <div className={screen ? 'wf-fill' : 'wf-split'} style={{ gridTemplateColumns: '1fr 1fr' }}>
        <Cell tone="hero">Série A · 50%</Cell>
        <Cell tone="hero">Série B · 50%</Cell>
      </div>
      <Cell tone="support" className="wf-cell--feed">
        Desvios / variações · 100%
      </Cell>
    </div>
  )
}

function WireOps({ screen }) {
  return (
    <div className={screen ? 'wf-screen' : 'wf-stack'}>
      <div className={screen ? 'wf-fill' : 'wf-split'} style={{ gridTemplateColumns: '1fr 1fr' }}>
        <Cell tone="hero">Status ao vivo · 50%</Cell>
        <Cell tone="hero">Fila / alerta · 50%</Cell>
      </div>
      <div className={screen ? 'wf-fill' : undefined}>
        <Cell className="wf-cell--feed">Feed contínuo / TV · 100%</Cell>
      </div>
    </div>
  )
}

const TYPES = [
  { id: 'z', nome: 'Clássico em Z', desc: 'Visão geral, indicadores e diagnóstico.' },
  { id: '7030', nome: '70/30', desc: 'Um foco principal com apoio lateral.' },
  { id: 'explore', nome: 'Exploração', desc: 'Filtros, busca, agrupamentos e drill-down.' },
  { id: 'exec', nome: 'Executiva', desc: 'Síntese para decisão rápida.' },
  { id: 'compare', nome: 'Comparativa', desc: 'Diferenças, desvios e variações.' },
  { id: 'ops', nome: 'Operacional / TV', desc: 'Monitoramento contínuo.' },
]

const SPACING = [
  { token: '--lyt-gap-xs', px: 8, uso: 'Entre as faixas da mesma linha; chips; ícone+rótulo' },
  { token: '--lyt-gap-sm', px: 12, uso: 'Entre campos em formulário compacto' },
  { token: '--lyt-gap-md', px: 16, uso: 'Gap padrão entre componentes na mesma zona' },
  { token: '--lyt-gap-lg', px: 24, uso: 'Entre zonas (faixa ↔ herói ↔ apoio)' },
  { token: '--lyt-gap-xl', px: 32, uso: 'Respiro de página / seção principal' },
]

const ZONE_MAP = [
  {
    tipo: 'Clássico em Z',
    zonas: [
      { zona: 'Faixa 4×25%', comps: 'divisão livre' },
      { zona: 'Herói', comps: 'chart' },
      { zona: 'Apoio', comps: 'alertas, lista curta, timeline' },
      { zona: 'Base', comps: 'chart secundário, tabela resumo' },
    ],
  },
  {
    tipo: '70/30',
    zonas: [
      { zona: 'Faixa 4×25%', comps: 'divisão livre' },
      { zona: '70% principal', comps: 'form, tabela, chart' },
      { zona: '30% apoio', comps: 'progresso, ajuda, resumo' },
    ],
  },
  {
    tipo: 'Exploração',
    zonas: [
      { zona: 'Filtros 25%', comps: 'filtros, typeahead' },
      { zona: 'Faixa ×3 (25% cada)', comps: 'divisão livre' },
      { zona: 'Análise 75%', comps: 'chart' },
      { zona: 'Detalhe 75%', comps: 'table' },
    ],
  },
  {
    tipo: 'Executiva',
    zonas: [
      { zona: 'Resumo', comps: 'texto / status' },
      { zona: 'Faixa 4×25%', comps: 'divisão livre' },
      { zona: 'Único gráfico', comps: 'chart (só um)' },
    ],
  },
  {
    tipo: 'Comparativa',
    zonas: [
      { zona: 'Faixa ×3 (33%)', comps: 'divisão livre' },
      { zona: 'Painéis A/B', comps: 'chart × 2' },
      { zona: 'Desvios', comps: 'tabela ou alertas' },
    ],
  },
  {
    tipo: 'Operacional / TV',
    zonas: [
      { zona: 'Status', comps: 'blocos grandes' },
      { zona: 'Feed', comps: 'tabela / timeline contínua' },
    ],
  },
]

const NAV = [
  { nome: 'Abas', desc: 'Perspectivas do mesmo objeto sem sair do contexto.' },
  { nome: 'Filtros', desc: 'Refinar grandes conjuntos de informação.' },
  { nome: 'Drill-down', desc: 'Sair da síntese e aprofundar o detalhe.' },
  { nome: 'Master-Detail', desc: 'Lista de registros com detalhe do item selecionado.' },
  { nome: 'Drawer', desc: 'Detalhe ou ação lateral sem abandonar a tela.' },
  { nome: 'Modal', desc: 'Interrupção pontual para confirmação ou ação.' },
  { nome: 'Etapas', desc: 'Processo guiado com sequência obrigatória.' },
  { nome: 'Breadcrumb', desc: 'Retorno em estruturas hierárquicas.' },
]

function DetailShell({ title, blurb, foot, children }) {
  return (
    <Box className="wf-demo">
      <WfStyles />
      <header className="wf-demo__head">
        <h3>{title}</h3>
        <p>{blurb}</p>
      </header>
      {children}
      {foot ? <p className="wf-demo__foot">{foot}</p> : null}
    </Box>
  )
}

const MOCKS = {
  layoutOverview: () => (
    <Box className="wf-demo">
      <WfStyles />
      <div className="wf-overview">
        <Frame title="1. Clássico em Z">
          <WireZ />
        </Frame>
        <Frame title="2. 70/30">
          <Wire7030 />
        </Frame>
        <Frame title="3. Exploração">
          <WireExplore />
        </Frame>
        <Frame title="4. Executiva">
          <WireExec />
        </Frame>
      </div>
      <div className="wf-types">
        {TYPES.map((t) => (
          <div key={t.id} className="wf-type">
            <strong>{t.nome}</strong>
            <span>{t.desc}</span>
          </div>
        ))}
      </div>
      <p className="wf-demo__foot">
        Comparativa e Operacional/TV completam os 6 tipos (demos nas abas seguintes). Tipo ≠
        navegação.
      </p>
    </Box>
  ),

  layoutZ: () => (
    <DetailShell
      title="Clássico em Z"
      blurb="Olho segue a faixa de 25% → herói → apoio lateral → base. Bom para dashboard de diagnóstico."
      foot="4 faixas de 25% · herói 75% · apoio 25% · base 50/50. A faixa marca a divisão, não um componente."
    >
      <Frame title="Alocação" note="A tela preenche a área. Herói 75% e apoio 25% na mesma linha." screen>
        <WireZ screen />
      </Frame>
    </DetailShell>
  ),

  layout7030: () => (
    <DetailShell
      title="70 / 30"
      blurb="Um bloco carrega a tarefa; a coluna direita só apoia (ajuda, progresso, contexto)."
      foot="Faixa 4×25%. Principal 70% e apoio 30% preenchem a altura restante. O corte não é o 75/25 do Z."
    >
      <Frame title="Alocação" note="70% e 30% na mesma linha, os dois na mesma altura." screen>
        <Wire7030 screen />
      </Frame>
    </DetailShell>
  ),

  layoutExplore: () => (
    <DetailShell
      title="Exploração"
      blurb="Trilho de filtros fixo; análise no centro; tabela para aprofundar."
      foot="Grade 4×25%: filtro + 3 faixas na primeira linha; análise e detalhe nos 75% à direita."
    >
      <Frame
        title="Alocação"
        note="Filtro = 1 col (25%) na altura toda. Três faixas de 25%. Análise e detalhe preenchem o resto."
        screen
      >
        <WireExplore screen />
      </Frame>
    </DetailShell>
  ),

  layoutExec: () => (
    <DetailShell
      title="Executiva"
      blurb="Pouca densidade: resumo → faixa de 25% → um gráfico. Sem ruído."
      foot="Resumo 100% · 4 faixas de 25% · um gráfico que preenche o resto."
    >
      <Frame title="Alocação" note="O gráfico ocupa a altura que sobra." screen>
        <WireExec screen />
      </Frame>
    </DetailShell>
  ),

  layoutCompare: () => (
    <DetailShell
      title="Comparativa"
      blurb="Dois (ou mais) painéis equivalentes + faixa de desvio abaixo."
      foot="3 faixas de 33% · painéis 50/50 na altura principal · desvios 100%."
    >
      <Frame title="Alocação" note="As duas séries ocupam a mesma altura." screen>
        <WireCompare screen />
      </Frame>
    </DetailShell>
  ),

  layoutOps: () => (
    <DetailShell
      title="Operacional / TV"
      blurb="Zonas grandes, tipografia forte, atualização contínua — mural ou sala de operação."
      foot="50%/50% + feed 100%."
    >
      <Frame title="Alocação" note="Status e fila 50/50, feed embaixo. Os dois blocos preenchem a tela." screen>
        <WireOps screen />
      </Frame>
    </DetailShell>
  ),

  layoutSpacing: () => (
    <Box className="wf-demo">
      <WfStyles />
      <p className="wf-demo__lead">
        Use estes gaps ao montar zonas. Não misturar com letter-spacing da tipografia MIV.
      </p>
      <div className="wf-spacing-list">
        {SPACING.map((s) => (
          <div key={s.token} className="wf-spacing-row">
            <div className="wf-spacing-row__meta">
              <code>{s.token}</code>
              <strong>{s.px}px</strong>
              <span>{s.uso}</span>
            </div>
            <div className="wf-spacing-row__viz" style={{ gap: s.px }}>
              <i />
              <i />
              <i />
            </div>
          </div>
        ))}
      </div>
      <div className="wf-spacing-sample">
        <Wire7030 />
      </div>
    </Box>
  ),

  layoutZones: () => (
    <Box className="wf-demo">
      <WfStyles />
      <p className="wf-demo__lead">
        Escolha o <strong>tipo</strong> primeiro; só então encaixe componentes L1 nas zonas.
      </p>
      <div className="wf-zone-map">
        {ZONE_MAP.map((row) => (
          <div key={row.tipo} className="wf-zone-map__card">
            <strong>{row.tipo}</strong>
            <ul>
              {row.zonas.map((z) => (
                <li key={z.zona}>
                  <span>{z.zona}</span>
                  <code>{z.comps}</code>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <p className="wf-demo__foot">
        Fórmula: <strong>Tela final = Tipo de tela + Navegação + Componentes + Estados</strong>
      </p>
    </Box>
  ),

  layoutNav: () => (
    <Box className="wf-demo">
      <WfStyles />
      <p className="wf-demo__lead">
        Padrões de navegação/interação — <em>não</em> substituem o tipo de tela.
      </p>
      <div className="wf-nav">
        {NAV.map((n) => (
          <div key={n.nome} className="wf-nav__item">
            <strong>{n.nome}</strong>
            <span>{n.desc}</span>
          </div>
        ))}
      </div>
      <p className="wf-demo__foot">
        Ex.: tela <strong>70/30</strong> + navegação <strong>etapas</strong> + form + estados =
        ficha cadastral.
      </p>
    </Box>
  ),
}

export default function LayoutMock({ mockId }) {
  const Comp = MOCKS[mockId]
  if (!Comp) {
    return (
      <Box>
        <p className="text-muted mb-0">Mock layout não encontrado: {mockId}</p>
      </Box>
    )
  }
  return <Comp />
}
